import { stripeCreateSubscription } from '../../util/api';
import { isFeatureFlagEnabled } from '../../util/localStorage';
import config from '../../config';

const DEFAULT_LT_PLUS_ANNUAL_PRICE = 29999;
const DEFAULT_LT_PLUS_MONTHLY_PRICE = 2999;

const getSubscriptionAmount = (value, fallbackAmount) => {
  const parsedAmount = Number.parseInt(value, 10);
  return Number.isNaN(parsedAmount) ? fallbackAmount : parsedAmount;
};

const annualSubscriptionPrice = getSubscriptionAmount(
  process.env.REACT_APP_LANDTRUST_PLUS_PRICE,
  DEFAULT_LT_PLUS_ANNUAL_PRICE
);
const monthlySubscriptionPrice = getSubscriptionAmount(
  process.env.REACT_APP_LANDTRUST_PLUS_MONTHLY_PRICE,
  DEFAULT_LT_PLUS_MONTHLY_PRICE
);

const getBuckChatConfig = (currentUser = null) => ({
  enableDebugLogs: isFeatureFlagEnabled(config.featureFlags.BUCK_CHAT_TRACES, currentUser),
  websocketUrl: process.env.REACT_APP_BUCK_CHAT_URL,
  feedbackUrl: process.env.REACT_APP_BUCK_FEEDBACK_URL,
  tokenUrl: process.env.REACT_APP_BUCK_TOKEN_URL || '/api/buck/token',
  // Auth config for signup flow
  apiBaseUrl: process.env.REACT_APP_CANONICAL_ROOT_URL || '',
  googleAuthUrl: '/api/auth/google',
  facebookAuthUrl: '/api/auth/facebook',
  // Stripe config for LT+ subscription flow
  stripe: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
    ? {
        publishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
        subscriptionPrice: annualSubscriptionPrice,
        subscriptionPlans: {
          annual: { amount: annualSubscriptionPrice },
          monthly: { amount: monthlySubscriptionPrice },
        },
        createSubscription: params => stripeCreateSubscription(params),
      }
    : undefined,
});

export default getBuckChatConfig;
